import { Link } from "react-router-dom";
import SiteFooter from "../components/SiteFooter";

const HowToFileITR = () => {
  return (
    <div className="bg-white text-gray-900">
      <div className="max-w-4xl mx-auto px-6 py-10">

        {/* Title */}
        <h1 className="text-3xl font-bold mb-4" style={{ fontFamily: "Fraunces, serif" }}>
          How to File ITR Using Form 16 (Step-by-Step Guide)
        </h1>

        <p className="text-sm opacity-70 mb-6">
          Updated for FY 2024-25 — Simple guide for salaried individuals in India
        </p>

        {/* Intro */}
        <p className="mb-6 leading-7">
          Filing your Income Tax Return (ITR) using Form 16 is the most common method
          for salaried individuals in India. If you have received Form 16 from your employer,
          you already have most of the information needed to file your return.
        </p>

        {/* Section 1 */}
        <h2 className="text-xl font-semibold mt-8 mb-3">
          What is Form 16?
        </h2>

        <p className="mb-6 leading-7">
          Form 16 is a certificate issued by your employer that contains details of
          your salary, tax deducted (TDS), and deductions claimed. It is divided into:
        </p>

        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Part A – TDS details</li>
          <li>Part B – Salary and deduction breakdown</li>
        </ul>

        {/* Section 2 */}
        <h2 className="text-xl font-semibold mt-8 mb-3">
          Steps to File ITR Using Form 16
        </h2>

        <ol className="list-decimal pl-6 space-y-3 mb-6">
          <li>Login to the income tax portal (incometax.gov.in)</li>
          <li>Select “File Income Tax Return”</li>
          <li>Choose Assessment Year</li>
          <li>Select ITR-1 (for salaried individuals)</li>
          <li>Enter salary details from Form 16</li>
          <li>Add deductions (80C, 80D, etc.)</li>
          <li>Verify tax computation</li>
          <li>Submit and e-verify your return</li>
        </ol>

        {/* Pain section */}
        <h2 className="text-xl font-semibold mt-8 mb-3">
          Common Problems While Filing ITR
        </h2>

        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Confusion between old and new tax regime</li>
          <li>Incorrect salary entry from Form 16</li>
          <li>Missing deductions</li>
          <li>Mismatch with Form 26AS</li>
        </ul>

        {/* CTA */}
        <div className="border rounded-xl p-6 mt-10 bg-gray-50">
          <h3 className="text-lg font-semibold mb-2">
            Want to simplify your ITR filing?
          </h3>
          <p className="text-sm mb-4 opacity-80">
            Instead of entering everything manually, you can upload your documents
            and complete your tax filing with guided support on MoolTax.
          </p>

          <Link
            to="/plans"
            className="inline-block px-5 py-2 rounded-lg text-white"
            style={{ backgroundColor: "var(--accent)" }}
          >
            Start Filing Now
          </Link>
        </div>

        {/* Section */}
        <h2 className="text-xl font-semibold mt-10 mb-3">
          Old vs New Tax Regime — Which to Choose?
        </h2>

        <p className="mb-6 leading-7">
          Choosing the correct tax regime is important. The old regime allows deductions,
          while the new regime offers lower tax rates. You should compare both before filing.
        </p>

        {/* Conclusion */}
        <h2 className="text-xl font-semibold mt-10 mb-3">
          Conclusion
        </h2>

        <p className="leading-7">
          Filing your ITR using Form 16 is simple if done correctly. However, to avoid
          mistakes and save time, using a guided platform can make the process much easier.
        </p>

      </div>

      <SiteFooter />
    </div>
  );
};

export default HowToFileITR;